export enum TextEnableLandlineRoutes {
  root = 'text-enable-landline',
  rootOld = 'landline',
  steps = 'steps',

  enterNumber = 'enter-number',
  enterAddress = 'enter-address',
  verifyNumber = 'verify-number',
  assignNumber = 'assign-number',
  authorizationDocument = 'authorization-document',
}
